import React, { useState, useEffect, useRef } from "react";
import firebase from "../../helpers/firebase";
import { localStore } from "../../helpers/localStorage";
import ProblemStatement from "../UiElements/ProblemStatement";
import { Button, Grid } from "@material-ui/core";
import { useHistory } from "react-router-dom";
import LatexPreview from "../UiElements/LatexPreview";
import Alert from "@material-ui/lab/Alert";
import QRCode from "react-qr-code";
import { v4 as uuidv4 } from "uuid";
import QuillNoteHeading from "../UiElements/QuillNoteHeading";
import PieSocket from "piesocket-js/src/PieSocket";
import { useLocation } from "react-router-dom";

function WriteAnswer() {
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const uuidRef = useRef(null);
  const message = useRef([]);
  const pickSocketRef = useRef({
    instance: null,
    channel: null,
  });
  const history = useHistory();
  let sessionId = localStore.getSession();
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [showConfirmDialog, setShowConfirmDialog] = useState(false);
  const [enteredAnswers, setEnteredAnswers] = useState(null);
  const [uniqueId, setUniqueId] = useState(null);
  const [exerciseStatus, setExerciseStatus] = useState("");

  useEffect(() => {
    if (!uuidRef.current) {
      const generatedUuid = uuidv4();
      uuidRef.current = generatedUuid;
      setUniqueId(uuidRef.current);
    }
  }, []);

  useEffect(() => {
    pickSocketRef.current.instance = new PieSocket({
      clusterId: "free.blr2",
      apiKey: "J4A0fS044R5rlh24Uc0Mz5KlkFpWSKBbeOGa5OBG",
      notifySelf: true,
    });
    pickSocketRef.current.instance.subscribe("chat-room").then((channel) => {
      pickSocketRef.current.channel = channel;
      console.log("Channel is ready");
      pickSocketRef.current.channel.listen("new_message", (data, meta) => {
        const matchId = data.unique_Id === uuidRef.current;
        if (matchId) {
          setExerciseStatus(data?.status);
          if (message.current !== null && message.current?.length) {
            if (data.is_undo) {
              const undoResultData = message.current.slice();
              undoResultData.splice(message.current.length - 1, 1);
              setEnteredAnswers(undoResultData);
            } else {
              data?.latex &&
                data?.asciimath &&
                setEnteredAnswers([...message.current, data]);
            }
          } else {
            if (!data.is_undo && data?.latex && data?.asciimath) {
              setEnteredAnswers([data]);
            }
          }
        }
      });
    });

    // Clean up the PieSocket connection on component unmount (optional)
    return pickSocketRef.current?.instance?.disconnect?.();
  }, []);

  useEffect(() => {
    if (enteredAnswers) {
      message.current = [...enteredAnswers];
    }
  }, [enteredAnswers]);

  const answerPreview = {
    paddingTop: "18px",
    background: "white",
    borderRadius: "20px",
    marginTop: "16px",
    fontSize: "1.8rem",
  };


  const submitAnswer = async () => {
    if (enteredAnswers && enteredAnswers?.length) {
      setShowConfirmDialog(true);
    } else {
      setError("Can not read the answer");
    }
  };

  const handleYes = async () => {
    setLoading(true);

    try {
      let steps = enteredAnswers?.map((item) => {
        return item.latex;
      });
      let data = { steps: steps };
      const db = firebase.firestore();
      await db
        .collection("sessions")
        .doc(sessionId)
        .collection("answers")
        .doc()
        .set(data);
      setLoading(false);
      pickSocketRef.current.channel.publish("submit_message", {
        unique_Id: uuidRef.current,
        sessionId: sessionId,
        status: "SUBMITTED",
      });
      setExerciseStatus("SUBMITTED");
      setEnteredAnswers([])
      setShowConfirmDialog(false);
    } catch (err) {
      console.log(err);
      setError(err);
    }
    setLoading(false);
  };

  const handleCancel = () => {
    setShowConfirmDialog(false);
  };

  const confirmDialog = () => (
    <>
      <div
        className="confirm primary"
        style={{
          zIndex: "1000",
          color: "black",
          borderRadius: "18px",
          padding: "0px 12px",
          position: "absolute",
        }}
      >
        <div style={answerPreview}>
          {enteredAnswers?.length &&
            enteredAnswers.map((item, index) =>
              !item.latex.includes("=") && !item.latex.includes("\\") ? (
                <pre style={{
                  margin:"0px"
                }}>{item.latex}</pre>
              ) : (
                <LatexPreview math={item.latex} />
              )
            )}
        </div>
        <span
          className="text-light"
          style={{ display: "block", margin: "36px 10px", fontSize: "26pt" }}
        >
          are you sure?
        </span>
        <div>
          <Button
            type="submit"
            variant="contained"
            size="large"
            className="CustomButton"
            style={{ margin: "10px" }}
            onClick={handleYes}
            disabled={loading}
          >
            Yes
          </Button>
          <Button
            type="submit"
            variant="contained"
            size="large"
            className="CustomButton"
            style={{ margin: "10px" }}
            onClick={handleCancel}
            disabled={loading}
          >
            Cancel
          </Button>
        </div>
      </div>
    </>
  );

  const renderWhiteBoard = (value) => {
    switch (value) {
      case "WAITING_STUDENTS":
        return <h2>awaiting an exercise</h2>;
      case "SUBMITTED":
        return <h2>submitted</h2>;
      case "TEST_END":
        return <h2>submitted</h2>;
      case "TEST_STARTED":
        return (
          <div  style={{width:"100%" ,height:"100vh"}}>
            <ProblemStatement type="smallTop" />
            <div
              style={{
                height:"calc(100% - 187px)",
                background: "white",
                marginBottom: "10px",
                display: "flex",
                justifyContent: "flex-start",
                flexDirection: "column",
                color: "#000",
              }}
            >
              {enteredAnswers &&
                enteredAnswers.length > 0 &&
                enteredAnswers.map((item, index) => (
                  <div className="problemStatement" key={index}>
                    <div className="exercise">
                      {item?.latex ? (
                        !item?.latex.includes("=") &&
                        !item?.latex.includes("\\") ? (
                          <pre style={{
                            fontSize: "2em",
                            margin:"0px"
                          }}>{`${item.latex}`}</pre>
                        ) : (
                          <LatexPreview className="math" math={item?.latex} />
                        )
                      ) : (
                        "loading.."
                      )}
                    </div>
                  </div>
                ))}
              <div
                style={{
                  marginTop: "auto",
                  position: "sticky",
                  bottom: "20px",
                }}
              >
                <Button
                  className={`CustomButton float-r`}
                  variant="contained"
                  size="large"
                  onClick={submitAnswer}
                  style={{ right: "40px" }}
                >
                  Submit
                </Button>
              </div>
            </div>
          </div>
        );
      default:
        break;
    }
  };

  return (
    <>
      {error && (
        <Alert className="error-top" severity="error">
          {error}
        </Alert>
      )}
      {showConfirmDialog ? confirmDialog() : ""}

      {exerciseStatus ? (
        renderWhiteBoard(exerciseStatus)
      ) : (
        <div>
          <QuillNoteHeading subHeading="student" />
          <Grid container style={{ justifyContent: "center" }}>
            <div>
              <p>
                <QRCode
                  value={`https://quillnote-29983.web.app/student/writting_pad?uniqueId=${uuidRef.current}&sessionId=${sessionId}`}
                />
              </p>
              <p>
                Scan QR code to begin</p>
                <a target="_blank" href={`http://localhost:3000/student/writting_pad?uniqueId=${uuidRef.current}&sessionId=${sessionId}`}>QR Link</a>
            </div>
          </Grid>
        </div>
      )}
    </>
  );
}

export default WriteAnswer;
